import { PageTemplate } from '@/shared/ui/templates';
import styles from './index.module.sass';
import classNames from 'classnames';
import { RecipeWidget } from '../../components/recipe-widget';

import { ArrowMulti, EqualSign } from '../../images';
import { MixingStep } from '../../components/mixing-step';
import { RecipeResultStep } from '../../components/recipe-result-step';
import { $recipeInfo, $recipeInfoLoadingStatus, cleanRecipeData, fetchRecipeData } from '@/widgets/recipe/model';
import { useParams, useSearchParams } from 'react-router-dom';
import { useStore } from 'effector-react';
import { useEffect, useRef, useState } from 'react';
import { Loader } from '@consta/uikit/Loader';
import { MultiBunker, SingleBunker } from '../../components/bunker-recipe';
import { SingleRecipeStepsModal } from '../../components/single-recipe-steps';
import { UniversalLoader } from '@/modules/common/components/universal-loader';

export const RecipeDetailsPage = () => {
  const { id } = useParams();
  const searchParams = new URLSearchParams(window.location.search);
  const bunkers = searchParams.get('bunker');
  const whId = searchParams.get('warehouse_id');
  const [displayModal, setDisplayModal] = useState(false);
  const [contentBlock, setContentBlock] = useState(null);
  const [activePair, setActivePair] = useState(0);

  const recipeInfoLoadingStatus = useStore($recipeInfoLoadingStatus);

  const data = useStore($recipeInfo);
  const [params] = useSearchParams();
  const ifViewOnly = !!(params.get('viewOnly'));

  useEffect(() => {
    fetchRecipeData({ id: Number(id), bunkers: JSON.parse(bunkers as string) });
    return () => {
      setActivePair(0);
      cleanRecipeData();
    };
  }, []);

  return (
    <PageTemplate
      mainClassName={styles.root}
      className={classNames(styles.background, styles.scrollable)}
      header="Рецепт миксования"
      customBack={ ifViewOnly ? -1 : "/mixing/recipes-new"}
    >
      {!data ? (
        <UniversalLoader error={recipeInfoLoadingStatus.error}/>
      ) : (
        <div className={styles.pageContainer}>
          <div className={styles.pageContent}>
            {data?.bunkers && data?.bunkers[0].type === 1 ? (
              <MultiBunker
                data={data}
                displayModal={() => setDisplayModal(true)}
                activePair={activePair}
                setActivePair={setActivePair}
              />
            ) : (
              <SingleBunker
                data={data}
                displayModal={() => setDisplayModal(true)}
                activePair={activePair}
                setActivePair={setActivePair}
              />
            )}
          </div>
          <SingleRecipeStepsModal
            presetExpanded={activePair}
            display={displayModal}
            closeFn={() => setDisplayModal(false)}
            data={data}
          />
        </div>
      )}
    </PageTemplate>
  );
};
